import { render, staticRenderFns } from "./ConfirmReceiptBox.vue?vue&type=template&id=34ff7f1e"
import script from "./ConfirmReceiptBox.vue?vue&type=script&lang=js"
export * from "./ConfirmReceiptBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports